import { Box, Text, Flex } from "@chakra-ui/layout";
import { Link, chakra } from "@chakra-ui/react";
import { Image } from "@chakra-ui/image";
import listOfNews from "./news-list";

//import useref
import { useRef, useEffect } from "react";

//import style object
import { filterStyle } from "../publications/publications";

export default function News() {
  const refContainer = useRef(null);
  useEffect(() => {
    refContainer.current.scrollIntoView({ behavior: "smooth" });
  }, []);
  return (
    <Box
      id="news"
      background="white"
      padding="1rem"
      minHeight="100vh"
      marginInlineStart={{ base: "0", md: "0.1rem", xl: "1rem" }}
      ref={refContainer}
    >
      <Box textAlign="center">
        <Text fontSize="4xl" fontWeight={700}>
          News
        </Text>
      </Box>
      <Box
        display="flex"
        flexWrap="wrap"
        gap="10px"
        alignItems="center"
        justifyContent="center"
        marginY="20px"
      >
        <Box
          style={filterStyle}
          _hover={{ background: "#473198", color: "white" }}
        >
          Grants &amp; Collaborations
        </Box>
        <Box
          style={filterStyle}
          _hover={{ background: "#473198", color: "white" }}
        >
          News &amp; Events
        </Box>
        <Box
          style={filterStyle}
          _hover={{ background: "#473198", color: "white" }}
        >
          Scholarships
        </Box>
        <Box
          style={filterStyle}
          _hover={{ background: "#473198", color: "white" }}
        >
          New &amp; Upcoming Projects
        </Box>
      </Box>

      <Flex
        flexDirection="row"
        flexWrap="wrap"
        alignItems="flex-start"
        justifyContent="center"
        paddingLeft="3%"
        paddingRight="5%"
        gap="20px"
      >
        {listOfNews.map((items) => {
          return (
            <Box
              key={items.id}
              marginBottom={10}
              width={{ base: "100%", md: "90%", xl: "40%" }}
              background="#f4f4f4"
              borderRadius="10px"
              boxShadow="md"
              _hover={{
                boxShadow: "lg",
                transition: "box-shadow 0.3s ease-in",
              }}
            >
              <Box flexShrink="0">
                <Image
                  src={items.image}
                  alt={items.image}
                  borderTopRightRadius="10px"
                  borderTopLeftRadius="10px"
                  objectFit="cover"
                />
              </Box>

              <Box
                paddingTop={{
                  base: "36px",
                  md: "38px",
                  lg: "37px",
                  xl: "37px",
                }}
                paddingBottom="5%"
                paddingLeft="5%"
                paddingRight="5%"
              >
                <Box minHeight="67px">
                  <Link
                    href={`/news/${items.slug}`}
                    fontSize="22px"
                    textAlign={{ base: "center", md: "start", xl: "start" }}
                    fontWeight={700}
                    _focus={{ textDecoration: "none" }}
                    isExternal
                  >
                    {items.title}
                  </Link>
                </Box>
                <Text fontWeight={700} marginY="10px">
                  Published On:
                  <chakra.span fontWeight={500}>
                    {new Date().toLocaleDateString()}
                  </chakra.span>
                </Text>
                <Text marginTop="20px" marginBottom="8px" textAlign="justify">
                  {items.article.slice(0, 200)}
                  <chakra.span>
                    <Link
                      href={`/news/${items.slug}`}
                      fontWeight={700}
                      _focus={{ textDecoration: "none" }}
                      isExternal
                    >
                      {"  "} ...Read More
                    </Link>
                  </chakra.span>
                </Text>
              </Box>
            </Box>
          );
        })}
      </Flex>
    </Box>
  );
}
